import HistoryIcon from '@mui/icons-material/History';
import {StoreStatusLogList} from './List';

const conf = {
    name: 'onpoint_store_status_log',
    icon: <HistoryIcon />,
    list: StoreStatusLogList,
    // edit:StoreStatusLogEdit,
    // show: ShowGuesser,
    options: {
        label: "Store Status",
        items: true
    }
};

export default conf